import { render, staticRenderFns } from "./BaseFilterTagItem.vue?vue&type=template&id=73cbe84a&scoped=true&"
import script from "./BaseFilterTagItem.vue?vue&type=script&lang=js&"
export * from "./BaseFilterTagItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cbe84a",
  null
  
)

export default component.exports